import React from 'react'
import { BreakdownPanel, BreakdownRow } from '../styles'

// Only what the row itself doesn't already say. Base, Patient fee, Total and
// the receipt icon are columns an inch above this panel, so restating them
// here buried the two fields a biller actually opens a row for: which card was
// used, and why it failed.
//
// `last4` and `lastErrorMessage` are not in the payload yet — the columns exist
// on billing_payments but the API doesn't serialize them. Each row renders only
// when its field is present, so they light up the moment the BE sends them
// without another frontend change. Same contract as `patientId` on the row.
const details = payment =>
  [
    payment.last4 && ['Card', `•••• ${payment.last4}`],
    payment.lastErrorMessage && ['Reason', payment.lastErrorMessage],
    Number(payment.feePercentageUsed) && [
      'Fee rate',
      `${payment.feePercentageUsed}%`,
    ],
    payment.stripePaymentId && ['Stripe payment ID', payment.stripePaymentId],
  ].filter(Boolean)

// Cash and check carry none of these: no card, no gateway error, no fee, no
// Stripe id. The row is the whole story, so PaymentRow hides the expander
// rather than open onto four empty dashes.
export const hasBreakdown = payment => details(payment).length > 0

const FeeBreakdownPanel = ({ payment }) => (
  <BreakdownPanel>
    {details(payment).map(([label, value]) => (
      <BreakdownRow key={label}>
        <span>{label}</span>
        <span>{value}</span>
      </BreakdownRow>
    ))}
  </BreakdownPanel>
)

export default FeeBreakdownPanel
